import React from "react";
import ImagePreview from "./ImagePreview";
import ImagePlaceHolder from "./ImagePlaceHolder";

export default function ImagePicker({
  cover,
  handleRevome,
  handlePick,
  previewStyles,
  placeHolderStyles,
}) {
  return cover ? (
    <ImagePreview
      src={cover}
      handleRevome={handleRevome}
      styles={{ ...previewStyles }}
    />
  ) : (
    <ImagePlaceHolder
      handleClick={handlePick}
      styles={{ ...placeHolderStyles }}
    />
  );
}
